<template>
	<div
		class="default-image"
		:class="`default-image--${size} default-image--${color} default-image--roundness-${roundness}`"
		data-cy="default-image"
	>
		<div
			:class="`default-image__illustration--${illustration}`"
			class="default-image__illustration"
			role="img"
			:aria-label="$t('aria-label.placeholder-image')"
		/>
	</div>
</template>

<script>

export default {
	name: 'DefaultImage',

	props: {
		color: {
			type: String,
			required: false,
			default: 'night-gray2',
			description: 'Sets the background colour of the DefaultImage. The colour provided must be one of those in the $colors-list.',
		},

		illustration: {
			type: String,
			required: false,
			default: 'landscape',
			validator: value => [
				'landscape',
			].indexOf(value) !== -1,
			description: 'Sets the DefaultImage\'s illustration',
		},

		roundness: {
			type: Number,
			required: false,
			default: 0,
			validator: roundness => roundness >= 0 && roundness <= 25,
			description: 'Sets the border-radius of the background',
		},

		size: {
			type: String,
			required: false,
			default: 'regular',
			validator: value => [
				'large',
				'regular',
				'small',
			].indexOf(value) !== -1,
			description: 'Sets the size of the DefaultImage',
		},
	},
};
</script>

<style lang="scss" src="./default-image.scss" />
